import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import ParticipationForm from './participate-form';
import PollForm from '../poll-form';

class MainContent extends Component {
	state = {
		openModal: false
	};

	toggleModal = () => {
		this.setState({
			openModal: !this.state.openModal
		});
	};

	render() {
		if (Object.keys(this.props.poll).length === 0) {
			return (
				<div>
					<h3 className="text-secondary">Welcome to smart poll application</h3>
					<p className="lead">
						You can create as many poll as you want. Click the new button to create a new poll.
					</p>
					<img
						className="ml-5"
						width="80%"
						src="https://cdn.dribbble.com/users/1823386/screenshots/3708312/poll.png"
						alt="Poll Image"
					/>
				</div>
			);
		}

		const { poll, getOpinion, updatePoll, deletePoll } = this.props;
		return (
			<div>
				<h3>{poll.title}</h3>
				<p>{poll.description}</p>
				<br />

				<ParticipationForm
					poll={poll}
					getOpinion={getOpinion}
					toggleModal={this.toggleModal}
					deletePoll={deletePoll}
				/>

				<Modal isOpen={this.state.openModal} toggle={this.toggleModal} unmountOnClose={true}>
					<ModalHeader toggle={this.toggleModal}>Update Poll</ModalHeader>
					<ModalBody>
						<PollForm poll={poll} isUpdate={true} submit={updatePoll} buttonValue="Update Poll" />
					</ModalBody>
				</Modal>
			</div>
		);
	}
}

export default MainContent;
